import { Box, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TotalBudgetSummary } from 'pages/calculator/MediaPlanning/Plan/Countries/NestedCountryTabs/CountryPlanSummary/TotalBudgetSummary/TotalBudgetSummary';
import DigitalBudgetTable from 'pages/calculator/MediaPlanning/common/BudgetTable/DigitalBudgetTable/DigitalBudgetTable';
import OfflineBudgetTable from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/OfflineBudgetTable';
import usePlanStore from 'store/planStore';
import { groupCalculatedBudgetTouchpointData } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/groupTouchpointData';
import useGenerateXls from '../../../PlanSummary/hooks/useGenerateXls';

function CountryPlanSummary() {
  const { t } = useTranslation();
  const { countryForms, selectedCountry } = usePlanStore();
  if (
    !selectedCountry ||
    (!countryForms[selectedCountry].savedCalculatedBudget?.length &&
      !countryForms[selectedCountry].offline?.tv?.offlineBudget)
  ) {
    return (
      <Box sx={{ p: '16px 21px 50px 21px' }}>
        <Typography color="error">
          {t('mediaPlanning.noCalculatedBudget')}
        </Typography>
      </Box>
    );
  }

  const processedData = countryForms[
    selectedCountry!
  ]?.offline?.tv?.offlineBudget?.map((budget) => {
    if (budget.touchpoint !== 'outdoor') {
      return budget;
    }

    return {
      ...budget,
      children:
        budget.children?.filter((child) => child.isIncludedInCalculations) ||
        [],
    };
  });

  return (
    <Box
      sx={{
        pt: '17px',
        pb: '50px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '40px',
      }}
    >
      <TotalBudgetSummary
        digital={countryForms[selectedCountry].savedCalculatedBudget}
        offline={countryForms[selectedCountry]?.offline?.tv?.offlineBudget}
      />
      <DigitalBudgetTable
        data={groupCalculatedBudgetTouchpointData(
          countryForms[selectedCountry]?.savedCalculatedBudget || []
        )}
      />
      <OfflineBudgetTable data={processedData || []} />
    </Box>
  );
}

export default CountryPlanSummary;
